import { useEffect } from 'react';
import { appendHoneyGuide } from '../lib/utils';

export default function useDocumentTitle(title, input) {
  useEffect(
    () => {
      if (title) document.title = appendHoneyGuide(title);
    },
    [input]
  );
}



// WEBPACK FOOTER //
// ./src/hooks/useDocumentTitle.js